import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Content, Section, TabMenu, TextDiv } from "../../styles/Common";
import { styled } from "styled-components";
import InquiryList from "../../components/myPage/InquiryList";
import Inquiry from "../../components/myPage/Inquiry";
import NoticeList from "../../components/service/NoticeList";
import { serviceActions } from "../../store/slices/serviceSlice";
import { getToken } from "../../components/hooks/authFunc";
import { useDispatch, useSelector } from "react-redux";
import NoHistory from "../../components/myPage/NoHistory";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";

const Notice = () => {
  const location = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const accessToken = getToken();
  const data = useSelector((state) => state.service.noticeList);
  const getData = () => {
    const params = {};
    dispatch(serviceActions.fetchNoticeList({ params, accessToken }));
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <OnlyHeaderLayout title="공지사항">
      <Section className="minPaddingTop">
        <Content>
          {data && data.count > 0 ? <NoticeList data={data} /> : <NoHistory />}
        </Content>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default Notice;
